<template>
  <div class="Projects">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Proyectos en IK
              <v-spacer/>

              <v-text-field
                :disabled="dataVals.length < 0 || loading"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer/>

              <!-- <v-card-actions>
                <v-btn color="info" :disabled="dataVals.length === 0">
                  <download-csv
                    :data="dataVals"
                    :name="''"
                    :labels="labelsTotal"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions> -->

              <v-dialog v-model="dialog" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="loading"
                    color="info" dark v-on="on"
                  >
                    Nuevo Proyecto
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="form"
                    >
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedProject.nombre_proyecto"
                              label="Nombre Proyecto*"
                              :rules="nameRules"
                              counter="50"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="editedProject.descripcion"
                              auto-grow
                              label="Descripción"
                              rows="1"
                              :rules="descriptionRules"
                              counter="1000"
                            ></v-textarea>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedProject.coordinador"
                              :items="coordinators"
                              item-text="nombre_completo"
                              label="Coordinador*"
                              :rules="coordinadorRules"
                              required
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedProject.estado"
                              :items="state"
                              label="Estado"
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedProject.fecha_inicio"
                              label="Fecha de Inicio"
                              type="date"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedProject.fecha_fin"
                              label="Fecha de Finalización"
                              type="date"
                            ></v-text-field>
                          </v-flex>

                          <!-- <v-flex xs6>
                            <v-text-field
                              v-model="editedProject.precio"
                              label="Precio"
                            ></v-text-field>
                          </v-flex> -->
                          <!-- <v-flex xs6>
                            <v-text-field
                              v-model="editedProject.porcentaje_pago"
                              label="Porcentaje de pago"
                            ></v-text-field>
                          </v-flex> -->
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedProject.img"
                              label="URL Imagen"
                            ></v-text-field>
                          </v-flex>

                          <v-expansion-panel popout>
                            <v-expansion-panel-content>
                              <template v-slot:header>
                                <div>Seleccion de "Vistas Generales"</div>
                              </template>
                              <v-card-text>
                                <template v-for="view in views">
                                  <v-checkbox
                                    v-model="viewsAllow"
                                    :label="view"
                                    :value="view"
                                    :key="view"
                                  ></v-checkbox>

                                  <v-autocomplete
                                    :items="rol"
                                    label="Roles que no veran esta vista"
                                    v-model="viewRolExclude[view]"
                                    clearable
                                    :disabled="isActive(view)"
                                    chips
                                    color="secondary"
                                    item-text="text"
                                    item-value="value"
                                    multiple
                                    :key="view"
                                  >
                                  </v-autocomplete>
                                </template>
                              </v-card-text>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-layout>
                      </v-container>
                      <small>* Campos obligatorios</small>
                    </v-form>
                  </v-card-text>

                  <v-alert :value="alert" type="error">
                    No se ha podido realizar la operación
                  </v-alert>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" :disabled="uploading" @click="close()">Cancelar</v-btn>
                    <v-btn
                      :disabled="!form || uploading"
                      color="success"
                      @click="save()"
                    >Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                :key="tableProjectKey"
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
              >
                <template slot="items" slot-scope="props">
                  <td v-for="col in columns" :key="col.id">{{ props.item[col] }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      @click="editProject(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      color="error"
                      @click="deleteProject(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog v-model="dialogDelete" persistent max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Eliminar Proyecto</span>
                </v-card-title>
                <v-card-text>
                  Seguro que quiere eliminar el proyecto: <br>
                  <span class="title">
                    {{ editedProject.nombre_proyecto }}
                  </span> <br>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo eliminar los datos del proyecto"
                  ></v-checkbox>
                </v-card-text>

                <v-alert :value="alert" type="error">
                  No se ha podido eliminar el proyecto
                </v-alert>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" :disabled="uploading" @click="close()">Cancelar</v-btn>
                  <v-btn
                    color="error"
                    @click="byeProject()"
                    :disabled="!checkbox || uploading"
                  >Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import JsonPretty from 'vue-json-pretty'
// import JsonCSV from 'vue-json-csv'

export default {
  name: `Projects`,

  components: {
    // 'download-csv': JsonCSV,
    // 'pretty-json': JsonPretty
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.getProjects()
    this.getCoordinator()
  },

  data: function () {
    return {
      backConf: {
        pathList: '/core/projects/?page=',
        pathCUD: '/core/projects/', // Post sin documento demas con documento
        pathCoord: '/core/users/get_coord/',
        page: 1
      },

      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,

      loading: false,
      uploading: false,
      form: false,
      checkbox: false,

      alert: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        // { text: 'Imagen', value: 'img' },
        { text: 'Nombre', value: 'nombre_proyecto', align: 'left' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Coordinador', value: 'coordinador' },
        { text: 'Estado', value: 'estado' },
        { text: 'Inicio', value: 'fecha_inicio' },
        { text: 'Fin', value: 'fecha_fin' },
        { text: 'Precio', value: 'precio' },
        { text: 'Porcentaje de pago', value: 'porcentaje_pago' },
        // { text: 'Vistas', value: 'vistas' },
        { text: 'Acciones', value: '', align: 'left', sortable: false }
      ],
      dataVals: [],
      defaultProject: {
        'nombre_proyecto': '',
        'descripcion': '',
        'coordinador': null,
        'estado': true,
        'fecha_inicio': new Date().toISOString().substr(0, 10),
        'fecha_fin': null,
        'img': null,
        'precio': {},
        'porcentaje_pago': 1,
        'vistas': {}
      },
      tableProjectKey: 0,

      search: '',
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedProject: {
        'nombre_proyecto': '',
        'descripcion': '',
        'coordinador': null,
        'estado': true,
        'fecha_inicio': new Date().toISOString().substr(0, 10),
        'fecha_fin': null,
        'img': null,
        'precio': {},
        'porcentaje_pago': 1,
        'vistas': {}
      },

      viewsAllow: ['Avance', 'Multiple', 'Encuestador'],
      rol: [
        { text: 'Coordinador - IK', value: 'CIK' },
        { text: 'Cliente', value: 'CL' },
        { text: 'Coordinador - Campo', value: 'CC' },
        { text: 'Supervisor', value: 'S' },
        { text: 'Encuestador', value: 'EC' },
        { text: 'Enumerador', value: 'EN' },
        { text: 'Auditor', value: 'AU' }
      ],
      viewRolExclude: {
        'Dashboard': ['CL'],
        'Avance': ['CL'],
        'Multiple': ['CL'],
        'Frecuencia': ['CL'],
        'Encuestador': ['CL'],
        'Mapa': ['CL'],
        'Audios Callcenter': ['CL'],
        'Validar Audios': ['CL'],
        'Incidencias': ['CL'],
        'Telefónico': ['CL']
      },

      coordinators: [],
      state: [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }],
      nameRules: [
        v => !!v || 'Se requiere nombre de proyecto',
        v => (v.length < 51) || 'Maximo 50 caracteres'
      ],
      descriptionRules: [
        v => !!v || 'Se requiere una descripción de proyecto',
        v => (v.length < 1001) || 'Maximo 1000 caracteres'
      ],
      coordinadorRules: [v => !!v || 'Se requiere un coordinador de proyecto']
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /** Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    },

    views () {
      return Object.keys(this.viewRolExclude)
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Proyecto' : 'Editar Proyecto'
    }
  },

  methods: {
    /** Carga la información de todos los proyectos
     */
    getProjects () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.tableProjectKey += 1
            t.getProjects()
          } else {
            t.backConf.page = 1
            t.tableProjectKey += 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.dataVals = []
          t.alert = true
          t.loading = false
          t.tableProjectKey += 1
          console.error(err)
        })
    },

    /** Carga la información de todos los coordinadores
     */
    getCoordinator () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.pathCoord
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.coordinators = resp.data
          t.tableProjectKey += 1
          t.loading = false
        })
        .catch(function (err) {
          t.coordinators = []
          t.tableProjectKey += 1
          t.loading = false
          console.error(err)
        })
    },

    /** Carga los datos del proyecto seleccionado y abre el dialog
     * @param  {Object} proyect El proyecto a editar
     */
    editProject (proyect) {
      this.editedIndex = this.dataVals.indexOf(proyect)
      this.editedProject = Object.assign({}, proyect)
      this.dialog = true

      // Carga los valores de las vistas del proyecto a editar
      this.viewsAllow = Object.keys(this.editedProject.vistas)
      this.viewsAllow.forEach(function (view) {
        this.viewRolExclude[view] = this.editedProject.vistas[view]
      }, this)
    },

    /** Carga los datos del proyecto seleccionado y abre el dialog
     * @param  {Object} proyect El proyecto a eliminar
     */
    deleteProject (proyect) {
      this.editedIndex = this.dataVals.indexOf(proyect)
      this.editedProject = Object.assign({}, proyect)
      this.dialogDelete = true
    },

    /** Elimina el usaurio seleccionado, previa confirmación
     * actualiza la tabla local
     */
    byeProject () {
      this.uploading = true
      let request = {
        method: 'delete',
        data: {},
        url: this.backConf.pathCUD + this.editedProject.id + '/'
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.uploading = false
          t.tableProjectKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableProjectKey += 1
          console.error(err)
        })
    },

    /** Limpia el formulario de proyecto y limpia los elementos asociados
     */
    close () {
      this.dialog = false
      this.alert = false
      this.dialogDelete = false
      setTimeout(() => {
        this.editedProject = Object.assign({}, this.defaultProject)
        this.editedIndex = -1
      }, 300)
    },

    /** Guarda la información del proyecto,
     * sea un proyecto nuevo o una actualización
     * actualiza la tabla local
     */
    save () {
      this.uploading = true
      let cordName = this.editedProject.coordinador
      // Cambia el nombre del coordinador por el código para hacer el post
      let cord = this.coordinators.filter(cord => cord.nombre_completo === cordName)
      this.editedProject.coordinador = cord[0].id

      // Se encarga de agregar las vistas con los roles excluidos
      let viewToAsign = {}
      this.viewsAllow.forEach(function (view) {
        viewToAsign[view] = this.viewRolExclude[view]
      }, this)
      this.editedProject.vistas = viewToAsign

      let request = {
        method: this.editedIndex > -1 ? 'put' : 'post',
        data: this.editedProject,
        url: this.editedIndex > -1 ? this.backConf.pathCUD + this.editedProject.id + '/' : this.backConf.pathCUD
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          // Retoma el nombre del coordinador para la insericón directa
          t.editedProject.coordinador = cordName
          if (t.editedIndex > -1) {
            Object.assign(t.dataVals[t.editedIndex], t.editedProject)
          } else {
            t.dataVals.push(t.editedProject)
          }
          t.alert = false
          t.uploading = false
          t.tableProjectKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableProjectKey += 1
          console.error(err)
        })
    },

    /** Valida si la vista esta activa para permitir la edición de los roles
     * @param  {string}  view La vista a validar
     * @return {Boolean}      El valor que deshabilitar el autocomplete del view
     */
    isActive (view) {
      return !this.viewsAllow.includes(view)
    }
  }
}
</script>
